import {Injectable} from '@angular/core';
import {Customer} from 'ApiGen/CustomerVerificationV2/model/models';
import {CustomerVerificationV2, OnboardingRequest, ShoppingCart, Product} from '../model/models';
import {ApplicationLogsRequest} from "leia-api";
import {NGXLogger} from "ngx-logger";
import { SessionStorageService } from './session-storage.service';
import {Promotion} from "../model/promotion";

const APPLICATION_LOG_REQUEST_SESSION_KEY = "application-log-request";
const ONBOARDING_REQUEST_SESSION_KEY = "onboarding-request";
const APPLIED_PROMOTIONS = "applied-promotions";

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {
  public customer: Customer = new CustomerVerificationV2("", "", "", "");
  private shoppingCart: ShoppingCart = new ShoppingCart();

  get onboardingRequest(): OnboardingRequest {
    let onboarding = this.sessionStorageService.get(ONBOARDING_REQUEST_SESSION_KEY);
    if (!onboarding) {
      onboarding = new OnboardingRequest();
      this.onboardingRequest = onboarding;
    }
    return onboarding;
  }

  set onboardingRequest(request: OnboardingRequest) {
    this.sessionStorageService.set(ONBOARDING_REQUEST_SESSION_KEY, request);
  }

  get applicationLogsRequest(): ApplicationLogsRequest {
    let applicationLog = this.sessionStorageService.get(APPLICATION_LOG_REQUEST_SESSION_KEY);
    if (!applicationLog) {
      applicationLog = new ApplicationLogsRequest();
      this.applicationLogsRequest = applicationLog;
    }
    return applicationLog;
  }

  set applicationLogsRequest(request: ApplicationLogsRequest) {
    this.sessionStorageService.set(APPLICATION_LOG_REQUEST_SESSION_KEY, request);
  }

  get applicationPromotions(): Array<Promotion> {
    let applicationPromotions = this.sessionStorageService.get(APPLIED_PROMOTIONS);
    if (!applicationPromotions) {
      applicationPromotions = [];
      this.applicationPromotions = applicationPromotions;
    }
    return applicationPromotions;
  }

  set applicationPromotions(value: Array<Promotion>) {
    this.sessionStorageService.set(APPLIED_PROMOTIONS, value);
  }

  /**
   * Constructor
   * @param logger Logger Instance
   */
  constructor(
    private logger: NGXLogger,
    private sessionStorageService: SessionStorageService
  ) { }

  /**
   * Get list of products in the cart.
   */
  getCartItems() {
    return this.shoppingCart.getCartItems();
  }

  /**
   * Add cart item
   * @param product Product to add
   */
  addCartItem(product: Product): void {
    this.shoppingCart.addCartItem(product);
  }

  /**
   * Clear all products from the cart.
   */
  clearCart() {
    this.clearCart();
  }
}
